<template>
  <div>
    <div class="outdoor-pricelist-detail" v-if="!isModalLoading">
      <div class="outdoor-pricelist-detail__photos">
        <div>
        <grid-card :min="100" :column="'5'" :gap="8">
          <template slot="item">
            <img v-for="(image, index) in imageUrl" :key="index" class="img-rounded" :src="image ? image : placeHolder" alt >
           
            <!-- <img v-else class="img-rounded" :src="placeHolder"> -->
          </template>
        </grid-card>
         </div>
      </div>
      <div v-if="optDay" class="outdoor-pricelist-detail__row">
        <div class="subhead">Opt Day per Month</div>
        <h1>{{pluralize(optDay, 'Day')}}</h1>
      </div>
      <div v-if="impression" class="outdoor-pricelist-detail__row">
        <div class="subhead">Est. Impression Per Month</div>
        <h1>{{impression | formatNumber}}</h1>
      </div>
      <div v-if="distance" class="outdoor-pricelist-detail__row">
        <div class="subhead">Est. Distance Per Day (Km)</div>
        <h1>{{distance}} Km</h1>
      </div>
      <div v-if="vehicle" class="outdoor-pricelist-detail__row">
        <div class="subhead">Vehicle Type</div>
        <h1>{{vehicle}}</h1>
      </div>
      <div v-if="trip" class="outdoor-pricelist-detail__row">
        <div class="subhead">Est. Trip Per Day</div>
        <h1>{{trip}} Trip</h1>
      </div>
      <div v-if="passenger" class="outdoor-pricelist-detail__row">
        <div class="subhead">Average Passenger Per Month</div>
        <h1>{{passenger}} Person</h1>
      </div>
      <div v-if="description" class="outdoor-pricelist-detail__description">
        <h1 class="subhead">Placement Description</h1>
        <div class="subhead">{{description}}</div>
      </div>
    </div>
    <a-loading v-else />
  </div>
</template>

<script>
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";

import { ALoadingPrimary } from "ui-kit-v1";
import tooltip from '@/components/Tooltip';

export default {
  name: "adx-outdoor-placement-detail",
  components: {
    "a-loading": ALoadingPrimary,
    "tooltip": tooltip
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      optDay: null,
      impression: null,
      distance: null,
      vehicle: null,
      trip: null,
      passenger: null,
      description:null,
      imageUrl: null,
      placeHolder: "/img/notfound/img-placeholder_square.jpg"
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async loadData() {
      this.isModalLoading = true;
      const { data, status } = await api.get(
        restEdge.busPricelistDetail(this.placementId),
        { needToken: true, useRestEdge: true }
      );

      if (status === 200) {
        this.optDay = data.route.operation_day;
        this.impression = data.route.est_impression;
        this.distance = data.route.est_distance;
        this.vehicle = data.route.vehicle_type_name;
        this.trip = data.route.est_trip;
        this.passenger = data.route.average_passenger;
        this.description = data.description;
        if(data.placement_photo.length > 0){
          this.imageUrl = data.placement_photo.map(data => data.thumb);
        }
      }

      this.isModalLoading = false;
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`;
      }

      return `${value} ${label}`;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
